import React, { useState, useEffect } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import { useNavigate } from "react-router-dom";

const translations = {
  ENGLISH: {
    companyBusinessDescription: "Company/Business Description",
    select: "Select",
    diary: "Diary",
    nonDiary: "Non Diary",
    describeBusiness: "Please Describe Your Business",
    ifAddressNotConfirm: "If Address Not Confirm",
    landmark: "Landmark",
    meetingWith: "Meeting with",
    self: "Self",
    father: "Father",
    mother: "Mother",
    spouse: "Spouse",
    son: "Son",
    daughter: "Daughter",
    ownedByApplicant: "Owned By Applicant",
    parental: "Parental",
    rented: "Rented",
    metPersonName: "Met Person Name",
    metPersonRelation: "Met Person Relation",
    ownership: "Ownership",
    ifRented: "If Rented (Rent Amt. & Landlord Name)",
    landlordName: "Landlord Name",
    landlordMobile: "Landlord Mobile Number",
    stabilityYears: "Stability Years",
    houseType: "House Type",
    kaccha: "Kaccha",
    pakka: "Pakka",
    namePlate: "Name Plate",
    seen: "Seen",
    notSeen: "Not Seen",
    totalRoom: "Total Room",
    oneBHK: "1 BHK",
    twoBHK: "2 BHK",
    threeBHK: "3 BHK",
    fourBHK: "4 BHK",
    fiveBHK: "5 BHK & Above",
    tpc1Name: "Tpc 1 Name",
    tpc1Mobile: "Tpc 1 Mobile",
    tpc2Name: "Tpc 2 Name",
    tpc2Mobile: "Tpc 2 Mobile",
    additionalRemarks: "Additional Remarks",
  },
  HINDI: {
    companyBusinessDescription: "कंपनी/व्यवसाय विवरण",
    select: "चयन करें",
    diary: "डेयरी",
    nonDiary: "गैर डेयरी",
    describeBusiness: "कृपया अपना व्यवसाय विवरण दें",
    ifAddressNotConfirm: "यदि पता पुष्टि नहीं है",
    landmark: "सीमाचिह्न",
    meetingWith: "मिलने वाले व्यक्ति",
    self: "स्वयं",
    father: "पिता",
    mother: "माता",
    spouse: "पति/पत्नी",
    son: "पुत्र",
    daughter: "पुत्री",
    ownedByApplicant: "आवेदक के स्वामित्व में",
    parental: "माता-पिता का",
    rented: "किराए पर",
    metPersonName: "मिलने वाले व्यक्ति का नाम",
    metPersonRelation: "मिलने वाले व्यक्ति का संबंध",
    ownership: "स्वामित्व",
    ifRented: "यदि किराए पर (किराया राशि और मकान मालिक का नाम)",
    landlordName: "मकान मालिक का नाम",
    landlordMobile: "मकान मालिक का मोबाइल नंबर",
    stabilityYears: "स्थिरता वर्ष",
    houseType: "मकान का प्रकार",
    kaccha: "कच्चा",
    pakka: "पक्का",
    namePlate: "नाम पट्टिका",
    seen: "देखा गया",
    notSeen: "नहीं देखा गया",
    totalRoom: "कुल कमरे",
    oneBHK: "1 बीएचके",
    twoBHK: "2 बीएचके",
    threeBHK: "3 बीएचके",
    fourBHK: "4 बीएचके",
    fiveBHK: "5 बीएचके और ऊपर",
    tpc1Name: "टीपीसी 1 नाम",
    tpc1Mobile: "टीपीसी 1 मोबाइल",
    tpc2Name: "टीपीसी 2 नाम",
    tpc2Mobile: "टीपीसी 2 मोबाइल",
    additionalRemarks: "अतिरिक्त टिप्पणी",
  },
  GUJARATI: {
    companyBusinessDescription: "કંપની/વ્યવસાય વર્ણન",
    select: "પસંદ કરો",
    diary: "ડેરી",
    nonDiary: "બિન-ડેરી",
    describeBusiness: "કૃપા કરી તમારા વ્યવસાયનું વર્ણન કરો",
    ifAddressNotConfirm: "જો સરનામું પુષ્ટિ ન થાય",
    landmark: "લૅન્ડમાર્ક",
    meetingWith: "મુલાકાત કોણ સાથે",
    self: "પોતે",
    father: "પિતા",
    mother: "માતા",
    spouse: "પત્ની/પતિ",
    son: "પુત્ર",
    daughter: "દીકરી",
    ownedByApplicant: "અરજદારના માલિકી",
    parental: "માતાપિતા",
    rented: "ભાડે પર",
    metPersonName: "મળેલા વ્યક્તિનું નામ",
    metPersonRelation: "મળેલા વ્યક્તિનો સંબંધ",
    ownership: "માલિકી",
    ifRented: "જો ભાડે (ભાડું અને માલિકનું નામ)",
    landlordName: "માલિકનું નામ",
    landlordMobile: "માલિકનો મોબાઇલ નંબર",
    stabilityYears: "સ્થિરતા વર્ષ",
    houseType: "મકાનનો પ્રકાર",
    kaccha: "કાચા",
    pakka: "પાક્કા",
    namePlate: "નામની પ્લેટ",
    seen: "જોયું",
    notSeen: "ન જોવાયું",
    totalRoom: "કુલ રૂમ",
    oneBHK: "1 BHK",
    twoBHK: "2 BHK",
    threeBHK: "3 BHK",
    fourBHK: "4 BHK",
    fiveBHK: "5 BHK અને ઉપર",
    tpc1Name: "TPC 1 નામ",
    tpc1Mobile: "TPC 1 મોબાઇલ",
    tpc2Name: "TPC 2 નામ",
    tpc2Mobile: "TPC 2 મોબાઇલ",
    additionalRemarks: "વધારાની ટિપ્પણીઓ",
  },
};

export default function Page3Residence() {
  const navigate = useNavigate();
  const [cpvLanguage, setCpvLanguage] = useState("ENGLISH");

  useEffect(() => {
    const language = localStorage.getItem("cpvLanguage");
    console.log(language)
    setCpvLanguage(language);
  }, []);

  const [companyBusinessDescription, setCompanyBusinessDescription] = useState("");
  const [ifAddressNotConfirm, setIfAddressNotConfirm] = useState("");
  const [landmark, setLandmark] = useState("");
  const [metPersonName, setMetPersonName] = useState("");
  const [metPersonRelation, setMetPersonRelation] = useState("");
  const [ownership, setOwnership] = useState("");
  const [ifRented, setIfRented] = useState("");
  const [stabilityYears, setStabilityYears] = useState("");
  const [namePlate, setNamePlate] = useState("");
  const [totalRoom, setTotalRoom] = useState("");
  const [tpc1, setTpc1] = useState("");
  const [tpcRemarks1, setTpcRemarks1] = useState("");
  const [tpc2, setTpc2] = useState("");
  const [tpcRemarks2, setTpcRemarks2] = useState("");
  const [additionalRemarks, setAdditionalRemarks] = useState("");
  const [isNonDiarySelected, setIsNonDiarySelected] = useState(false);
  const [describeBusiness, setdescribeBusiness] = useState("");
  const [meetingWith, setmeetingWith] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [isRented, setIsRented] = useState(false);
  const [landlordName, setlandlordName] = useState("");
  const [landlordMobile, setlandlordMobile] = useState("");
  const [houseType, sethouseType] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem(
      "CompanyBusinessDescriptionCPV",
      companyBusinessDescription
    );
    localStorage.setItem("businessDescription", describeBusiness);
    localStorage.setItem("IfAddressNotConfirmCPV", ifAddressNotConfirm);
    localStorage.setItem("LandmarkCPV", landmark);
    localStorage.setItem("meetingWith", meetingWith);
    localStorage.setItem("MetPersonNameCPV", metPersonName);
    localStorage.setItem("MetPersonRelationCPV", metPersonRelation);
    localStorage.setItem("OwnershipCPV", ownership);
    localStorage.setItem("IfRentedCPV", ifRented);
    localStorage.setItem("landlordName", landlordName);
    localStorage.setItem("landlordMobile", landlordMobile);
    localStorage.setItem("StabilityYearsCPV", stabilityYears);
    localStorage.setItem("NamePlateCPV", namePlate);
    localStorage.setItem("houseType", houseType);
    localStorage.setItem("TotalRoomCPV", totalRoom);
    localStorage.setItem("Tpc1CPV", tpc1);
    localStorage.setItem("TpcRemarks1CPV", tpcRemarks1);
    localStorage.setItem("Tpc2CPV", tpc2);
    localStorage.setItem("TpcRemarks2CPV", tpcRemarks2);
    localStorage.setItem("AdditionalRemarksCPV", additionalRemarks);
    setTimeout(() => {
      navigate("/4");
    }, 2000);
  };

  const handleDropdownChange = (e) => {
    const value = e.target.value;
    setCompanyBusinessDescription(value);
    setIsNonDiarySelected(value === "NON-DIARY");
  };

  const handleMeetingWith = (e) => {
    const value = e.target.value;
    setmeetingWith(value);

    if (["FATHER", "MOTHER", "SPOUSE", "SON", "DAUGHTER"].includes(value)) {
      setShowInput(true);
    } else {
      setShowInput(false);
    }
  };

  const handleOwnership = (e) => {
    console.log(e.target.vale)
    const value = e.target.value;
    setOwnership(value);
    setIsRented(value === "Rented");
  };

  const handleTpcRemarks1Change = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setTpcRemarks1(value);
    }
  };

  const handleTpcRemarks2Change = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setTpcRemarks2(value);
    }
  };

  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Interview Details
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            {/* <label>
              Company/ Business Description{" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].companyBusinessDescription}<span style={{ color: "red" }}>*</span> </label>
            <select
              style={{ height: "2rem" }}
              name="company-business-description"
              value={companyBusinessDescription}   
              required
              onChange={handleDropdownChange}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="DIARY">{translations[cpvLanguage].diary}</option>
              <option value="NON-DIARY">{translations[cpvLanguage].nonDiary}</option>
            </select>
          
          </div>
          {isNonDiarySelected && (
            <div className="div-login">
              {/* <label>
            Please describe your business <span style={{ color: "red" }}>*</span>
          </label> */}
              <label>{translations[cpvLanguage].describeBusiness}<span style={{ color: "red" }}>*</span> </label>
              <input
                type="text"
                name="business-description"
                value={describeBusiness}
                onChange={(e) => setdescribeBusiness(e.target.value)}
                required
              />
            </div>
          )}
          <div className="div-login">
            {/* <label>
              If Address Not Confirm <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ifAddressNotConfirm}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="if-address-not-confirmed"
              value={ifAddressNotConfirm}
              onChange={(e) => setIfAddressNotConfirm(e.target.value)}
              required
            />
          </div>
       
          <div className="div-login">
            {/* <label>
              Landmark <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].landmark}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="landmark"
              value={landmark}
              onChange={(e) => setLandmark(e.target.value)}
              required
            />
          </div>

          <div className="div-login">
            {/* <label>
            Meeting with <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].meetingWith}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="meetingWith"
              required
              value={meetingWith}
              onChange={handleMeetingWith}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="SELF">{translations[cpvLanguage].self}</option>
              <option value="FATHER">{translations[cpvLanguage].father}</option>
              <option value="MOTHER">{translations[cpvLanguage].mother}</option>
              <option value="SPOUSE">{translations[cpvLanguage].spouse}</option>
              <option value="SON">{translations[cpvLanguage].son}</option>
              <option value="DAUGHTER">{translations[cpvLanguage].daughter}</option>
            </select>
          </div>

          {showInput && (
            <div className="div-login">
              {/* <label>
            Met Person Name <span style={{ color: "red" }}>*</span>
          </label> */}
              <label>{translations[cpvLanguage].metPersonName}<span style={{ color: "red" }}>*</span></label>
              <input
                type="text"
                name="metPersonName"
                value={metPersonName}
                onChange={(e) => setMetPersonName(e.target.value)}
                required
              />
            </div>
          )}
          {/* <div className="div-login">
            <label>
              Met Person Name <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="met-person-name"
              required
              value={metPersonName}
              onChange={(e) => setMetPersonName(e.target.value)}
            />
          </div> */}
          <div className="div-login">
            {/* <label>
              Met Person Relation <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].metPersonRelation}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="met-person-relation"
              required
              value={metPersonRelation}
              onChange={(e) => setMetPersonRelation(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Ownership <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].ownership}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="ownership"
              required
              value={ownership}
              onChange={handleOwnership}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Owned By Applicant">{translations[cpvLanguage].ownedByApplicant}</option>
              <option value="Parental">{translations[cpvLanguage].parental}</option>
              <option value="Rented">{translations[cpvLanguage].rented}</option>
            </select>
          </div>
          {isRented && (
            <div>
              <div className="div-login">
                {/* <label>
              If Rented (Rent Amt. & Landlord Name){" "}
              <span style={{ color: "red" }}>*</span>
            </label> */}
                <label>{translations[cpvLanguage].ifRented}<span style={{ color: "red" }}>*</span></label>
                <input
                  type="text"
                  name="if-rented"
                  required
                  value={ifRented}
                  onChange={(e) => setIfRented(e.target.value)}
                />
              </div>
              <div className="div-login">
                {/* <label>
              Landlord Name <span style={{ color: "red" }}>*</span>
            </label> */}
                <label>{translations[cpvLanguage].landlordName}<span style={{ color: "red" }}>*</span></label>
                <input
                  type="text"
                  name="landlordName"
                  value={landlordName}
                  onChange={(e) => setlandlordName(e.target.value)}
                  required
                />
              </div>
              <div className="div-login">
                {/* <label>
              Landlord Mobile Number <span style={{ color: "red" }}>*</span>
            </label> */}
                <label>{translations[cpvLanguage].landlordMobile}<span style={{ color: "red" }}>*</span></label>
                <input
                  type="text"
                  name="landlordMobile"
                  value={landlordMobile}
                  onChange={(e) => setlandlordMobile(e.target.value)}
                  required
                />
              </div>
            </div>
          )}

          <div className="div-login">
            {/* <label>
              Stability Years <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].stabilityYears}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="stability-years"
              required
              value={stabilityYears}
              onChange={(e) => setStabilityYears(e.target.value)}
            />
          </div>

          <div className="div-login">
            {/* <label>
              Name Plate <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].namePlate}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="name-plate"
              required
              value={namePlate}
              onChange={(e) => setNamePlate(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Seen">{translations[cpvLanguage].seen}</option>
              <option value="Not Seen">{translations[cpvLanguage].notSeen}</option>
            </select>
          </div>
          
          <div className="div-login">
            {/* <label>
            House Type <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].houseType}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="name-plate"
              required
              value={houseType}
              onChange={(e) => sethouseType(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Kaccha">{translations[cpvLanguage].kaccha}</option>
              <option value="Pakka">{translations[cpvLanguage].pakka}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Total Room <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].totalRoom}<span style={{ color: "red" }}>*</span></label>
            <select
              style={{ height: "2rem" }}
              name="total-room"
              required
              value={totalRoom}
              onChange={(e) => setTotalRoom(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="1 BHK">{translations[cpvLanguage].oneBHK}</option>
              <option value="2 BHK">{translations[cpvLanguage].twoBHK}</option>
              <option value="3 BHK">{translations[cpvLanguage].threeBHK}</option>
              <option value="4 BHK">{translations[cpvLanguage].fourBHK}</option>
              <option value="5 BHK & Above">{translations[cpvLanguage].fiveBHK}</option>
            </select>
          </div>
          
          <div className="div-login">
            {/* <label>
              Tpc 1 Name<span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc1Name}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-1"
              required
              value={tpc1}
              onChange={(e) => setTpc1(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 1 Mobile<span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc1Mobile}<span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              name="tpc-remarks-1"
              required
              value={tpcRemarks1}
              onChange={handleTpcRemarks1Change}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 2 Name<span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc2Name}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="tpc-2"
              required
              value={tpc2}
              onChange={(e) => setTpc2(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Tpc 2 Mobile<span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].tpc2Mobile}<span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              name="tpc-remarks-2"
              required
              value={tpcRemarks2}
              onChange={handleTpcRemarks2Change}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Additional Remarks <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].additionalRemarks}<span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="additional-remarks"
              required
              value={additionalRemarks}
              onChange={(e) => setAdditionalRemarks(e.target.value)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
